import { useNavigate } from "react-router-dom";
import { canAccessAdminPath } from "routes/access-policy";
import { useUserRole } from "../../../auth/roles";

/**
 * Navigate to a user's detail page — or `null` when the current role can't
 * open `/admin/userDetails` (coaches). Call sites must degrade to a
 * non-clickable rendering on `null`: keeping the click and letting the layout
 * catch-all bounce the coach back to the calendar loses their context with
 * zero feedback.
 */
export const useNavigateToUserDetails = (): ((userId: string) => void) | null => {
    const navigate = useNavigate();
    const role = useUserRole();
    if (!canAccessAdminPath(role, '/userDetails')) return null;
    return (userId: string) => {
        navigate(`/admin/userDetails?user=${userId}`);
    };
};
